export default __webpack_public_path__ + "static/media/rocket.57abb30c.svg";